/**
 * REV-1163: rule titles from the engine use Markdown code spans — STRUCTURE-12
 * is "Ensure that referenced `id` attributes exist in the document." Rendered
 * as plain text the backticks show literally, and a screen reader may announce
 * them ("grave accent").
 *
 * Deliberately not a Markdown parser: a title is plain text with, at most, a
 * few single-backtick spans. A backtick opens a span only when another one
 * closes it; an unpaired backtick is left as literal text. An empty span
 * (two adjacent backticks) is dropped rather than becoming an empty <code>.
 */
export type CodeSpanToken = { type: 'text' | 'code'; value: string };

export function splitCodeSpans(text: string): CodeSpanToken[] {
  const tokens: CodeSpanToken[] = [];
  let i = 0;
  while (i < text.length) {
    const open = text.indexOf('`', i);
    const close = open === -1 ? -1 : text.indexOf('`', open + 1);
    if (close === -1) {
      tokens.push({ type: 'text', value: text.slice(i) });
      break;
    }
    if (open > i) tokens.push({ type: 'text', value: text.slice(i, open) });
    if (close > open + 1) tokens.push({ type: 'code', value: text.slice(open + 1, close) });
    i = close + 1;
  }
  return tokens;
}

/**
 * The same text with paired backticks removed — for every plain-text sink: an
 * accessible name, aria-label, chart label, or a value sent to the API.
 */
export function stripCodeSpans(text: string): string {
  return splitCodeSpans(text)
    .map((tok) => tok.value)
    .join('');
}
